import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DrupalService } from 'src/app/services/drupal.service';
import { getStyle, stringSubstr } from 'src/app/utils.ts/helpers';

@Component({
  selector: 'app-event-loader',
  templateUrl: './event_loader.component.html',
  styleUrls: ['./event_loader.component.scss']
})
export class EventLoaderComponent implements OnInit {

  constructor(
    private router: Router,
    private drupalService: DrupalService
  ) { }

  stringSubstr = stringSubstr
  getthumbnail = getStyle
  @Input() data: any;
  isFilterPage: boolean = false;
  isLoading: boolean = true;
  startDate: string = '';
  endDate: string = '';
  filterType: string = history.state && history.state.type ? history.state.type : 'event';
  filterCategoryOptions: any[] = [];
  selectedCategory: any = document.getElementById('catSelect') || '';
  inputText: string = '';
  allEvents: any[] = [];
  eventDate = {};



  async ngOnInit(): Promise<void> {
    this.data.event_loader_events = this.data.event_loader_events.filter((event: any) => event.status === true  && event.moderation_state != 'archived');
    if (this.router.url === '/' || this.router.url === '/homepage') {
      return
    }
    this.isFilterPage = history.state.isFilterPage;
    if ((this.isFilterPage || this.isFilterPage == undefined) && this.filterType === 'event') {
      this.startDate = history.state && history.state.startDate ? this.toLocalISODate(history.state.startDate) : this.toLocalISODate(new Date());
      this.endDate = history.state && history.state.endDate ? this.toLocalISODate(history.state.endDate) : this.toLocalISODate(new Date());
      this.selectedCategory = history.state && history.state.category ? history.state.category : '';
      this.drupalService.getTaxonomyVocabulary('eventi').subscribe({
        next: async (data: any) => {
          this.filterCategoryOptions = data.data.map((category: any) => {
            return {
              name: category.name,
              value: category.drupal_internal__tid
            }
          });
          await this.onSearch();
        }, error: console.error
      });
    }

    //create field effective_date_period based on date
    if (this.data?.event_loader_events) {
      this.data.event_loader_events.forEach((event: any) => {
        if (event.event_date && Array.isArray(event.event_date) && event.event_date.length > 0) {
          const firstEventDate = event.event_date[0];
          const lastEventDate = event.event_date[event.event_date.length - 1];

          event.effective_date_period = {
            date_from: firstEventDate?.value || null,
            date_to: lastEventDate?.end_value || null
          };
        }
      });
    }

  }

  onDateClicked(date: Date) {
    this.router.navigate(['/vivere-il-comune/eventi'], { state: { isFilterPage: true, startDate: date, endDate: date, type: 'event' } });
  }
  toLocalISODate(inputDate: Date | string) {
    const date = new Date(inputDate);
    const offset = date.getTimezoneOffset() * 60000; // Convert offset to milliseconds
    // Since Italy is either UTC+1 or UTC+2, this adjustment accounts for that offset
    const adjustedDate = new Date(date.getTime() - offset);
    return adjustedDate.toISOString().split('T')[0];
  }

  filterData(inputText: string, startDate: string, endDate: string) {
    this.isLoading = true;
    const selectElement = document.getElementById('catSelect') as HTMLSelectElement;
    const selectedValue = selectElement.options[selectElement.selectedIndex].value;
    this.selectedCategory = selectedValue;
    this.inputText = inputText;
    this.startDate = startDate;
    this.endDate = endDate;
    this.onSearch();
  }

  async onSearch() {
    this.drupalService.ESQuerySearch('event', {
      "size": 1000,
      "sort": [
        { "data.changed": { "order": "desc" } }
      ],
      "query": {
        "bool": {
          "must": [
            ...(this.selectedCategory ? [{ "term": { "data.event_type.drupal_internal__tid": this.selectedCategory } }] : []),
            ...(this.inputText ? [{ "match": { "data.title": this.inputText } }] : []),
            ...(this.data.status ? [{ "term": { "data.status": true } }] : []),
            {
              "nested": {
                "path": "data.event_date",
                "query": {
                  "bool": {
                    "must": [
                      ...(this.startDate && this.endDate ? [{ "range": { "data.event_date.value": { "lte": this.endDate } } }, { "range": { "data.event_date.end_value": { "gte": this.startDate } } }] : []),
                    ]
                  }
                },
              }
            }
          ]
        }
      }
    }
    ).subscribe({
      next: (data: any) => {
        this.allEvents = data.hits.hits.map((item: any) => {
          return item.data
        });
        this.isLoading = false;

      },
      error: console.error
    });
  }
  onCatClick(event: Event, category: number) {
    this.isLoading = true;
    event.preventDefault();
    this.router.navigate(['/vivere-il-comune/eventi'], { state: { isFilterPage: true, category: category, type: 'event' } });
    this.selectedCategory = category;
    this.onSearch();
  }
  onEnterPressed($event: KeyboardEvent) {
    if ($event.key === 'Enter') {
      this.isLoading = true;
      this.onSearch();
    }
  }

  onLinkClick(event: Event) {
    event.preventDefault();
    this.router.navigate(['/vivere-il-comune/eventi'], { state: { isFilterPage: true, startDate: this.startDate, endDate: this.endDate, type: 'event' } });
  }
}